const RoutesPath = {
  // Authentication
  login: "/login",
  forgotPassword: "/forgot-password",
  otpVerify: "/otp-verify",
  resetPassword: "/reset-password",

  // - Dashboard
  classMaster: "/class-master",
  stateMaster: "/state-master",
  districtMaster: "/district-master",
  talukaMaster: "/taluka-master",
  subjectMaster: "/subject-master",
  pincodeMaster: "/pincode-master",
  viewStudyMaterial: "/view-study-materials",
  addStudyMaterial: "/add-study-materials",
  editStudyMaterial: "/edit-study-materials",
  viewQuestionBank: "/view-question-bank",
  addQuestionBank: "/add-question",
  editQuestionBank: "/edit-question",
  bulkUploadQuestions: "/bulk-upload-questions",
  profile: "/profile/",
  viewProfile: "/profile/view",
  changePasswordProfile: "/profile/change-password",
  blog: "/blog",
  editblog: "/edit-blog",
  blogcategory: "/blog-category",
  viewBlog: "/view-blog",
  
  seopage: "/seo",
  authors: "/view-authors",
  addAuthors: "/authors",
  editAuthors: "/edit-authors",
  addTestimonial: "/add-testimonial",
  editTestimonial: "/edit-testimonial",
  testimonial: "/view-testimonial",
  faqCategory: "/faq-category",
  addFaq: "/add-faq",
  editFaq: "/edit-faq",
  viewFaq: "/view-faq",
  contactList: "/Contacts",
  registrationPageListing: "/registration-page",
  registrationPageListingView: "/registration-page-view",
  bharatsetexamlisting: "/list-all-bharat-sat-package",
  coordinatorPageListing: "/coordinator-page",
  socialMediaContact: "/social-media-contact",
  privacyPolicy: "/privacy-policy",
  termsandConditions: "/terms-and-conditions",
  cancellationPolicy: "/cancellation-Policy",
  aboutUs: "/about",
  updateSlider: "/update-slider",
  updatemobilebanner: "/update-mobile-banner",
  viewMockTest: "/view-mock-test",
  addMockTest: "/add-mock-test",
  editMockTest: "/edit-mock-test",
  packages: "/packages",
  addPackages: "/add-packages",
  editPackages: "/edit-packages",
  viewPackages: "/view-packages",
  coordinator: "/coordinator",
  addCoordinator: "/add-coordinator",
  editCoordinator: "/edit-coordinator",
  viewCoordinator: "/view-coordinator",
  coordinatordetails: "/coordinator-details",
  commissionpercentage: "/commission-percentage",
  coordinatorpayout: "/coordinator-payout",
  packagePurchasedListing: "/package-purchased-list",

  //Sub Admin
  roleList: "/roles",
  setprivileges: "/privileges",
  addsubadmin: "/add-subAdmin",
  subadminlist: "/sub-admin-list",

  //Bharat Sat Exam
  bharatsetresult: "/bharaSat-Result",
  bharatsatexamresult: "/bharat-sat-exam-result",
  shedulestudent: "/view-shedule-batch",
  addshedulestudent: "/add-shedule-batch",
  studentbatchlist:"/student-batch-list",
  
  addshedulestudentinterview: "/add-shedule-interview",
  shedulestudentinterview: "/view-shedule-interview",
  hallticket: "/hall-ticket",
  listhallticket: "/list-hall-ticket",
  addbharatsetexam: "/add-bharatsat-exam",

  viewexam: "/view-exam",
  addexam: "/add-exam",
  editexam: "/edit-exam",
  viewbharatsatquestionbank: "/view-bharat-sat-question-bank",
  bharatSatQuestionsDetails: "/bharat-sat-questions-details",
  editstudentdetails: "/edit-student-details",

  //Reviewer
  reveiwerquestionslist: "/reveiwer-questions-list",
  reviewerhistory: "/reveiwer-history",
  revieweraddquestionbank: "/reveiwer-addquestion-bank",
  //Coupan
  coupanlisting: "/coupan-listing",
  editcoupan: "/edit-coupan",
  addcoupans: "/add-coupan",

//Students
 viewStudents: "/view-student",
  addStudents: "/add-student",
  editStudents: "/edit-student",
  bulkUploadStudents: "/bulk-upload-students",


  
};

export default RoutesPath;
